import React, {useContext, useEffect, useState} from 'react';
import {Context} from '../../index';
import Container from '../../components/ui/Container';
import Button from '../../components/ui/Button';
import SectionHeading from '../../components/ui/SectionHeading';
import Seo from '../../components/ui/Seo';
import ServiceCard from '../../components/ServiceCard/ServiceCard';
import PostBody from '../../components/postBody/postBody';
import ExamplesByCategoryModal from '../../components/ExamplesByCategoryModal/ExamplesByCategoryModal';
import {CONTACTS, SERVICE_GROUPS} from '../../data/siteData';
import {EXAMPLES_ROUTE, SERVICES_ROUTE} from '../../utils/const';
import mainImage from '../../images/main_img.jpg';
import styles from './MainPage.module.css';

const MainPage = () => {
    const {banners, global, posts} = useContext(Context);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedCategory, setSelectedCategory] = useState('');
    global.setIsAdminPage(false);

    useEffect(() => {
        Promise.allSettled([
            banners.loadBanners(),
            posts.loadPosts(1),
            posts.loadAvailableCategories(),
        ]).then(() => setIsLoading(false));
    }, [banners, posts]);

    return (
        <>
            <Seo
                title="4 Цвета"
                description="Полиграфическая компания 4 Цвета в Томске: печатная продукция, сувениры, макеты и дизайн."
            />
            <section className={styles.hero}>
                <Container className={styles.heroGrid}>
                    <div className={styles.heroContent}>
                        <p className={styles.kicker}>Полиграфия и рекламное производство в Томске</p>
                        <h1>
                            Печатаем всё, что помогает вашему бизнесу{' '}
                            <span className={styles.magicWord}>выделяться</span>
                        </h1>
                        <p className={styles.lead}>Полиграфия, сувенирная продукция и дизайн в Томске &ndash; от подготовки макета до готового тиража</p>
                        <div className={styles.heroActions}>
                            <Button variant="secondary" to={SERVICES_ROUTE}>Посмотреть услуги</Button>
                        </div>
                        <div className={styles.heroContacts}>
                            <strong>{CONTACTS.mobile}</strong>
                            <p>{CONTACTS.address}</p>
                        </div>
                    </div>
                    <div className={styles.heroVisual}>
                        <img src={mainImage} alt="Печатная продукция 4 Цвета" width="640" height="800"/>
                    </div>
                </Container>
            </section>

            <Container>
                <section className={styles.section} id="services">
                    <SectionHeading
                        eyebrow="Основные направления"
                        title="Подберём печать под задачу, тираж и&nbsp;материал"
                        text=""
                    />
                    <div className={styles.serviceGrid}>
                        {SERVICE_GROUPS.map((service) => (
                            <ServiceCard
                                key={service.title}
                                service={service}
                                linkable={false}
                                onClick={posts.isCategoryAvailable(service.exampleCategory)
                                    ? () => setSelectedCategory(service.exampleCategory)
                                    : undefined}
                            />
                        ))}
                    </div>
                    <div className={styles.sectionAction}>
                        <Button variant="secondary" to={SERVICES_ROUTE}>Все услуги</Button>
                    </div>
                </section>



                {!isLoading && posts.posts.length > 0 && (
                    <section className={styles.section}>
                        <SectionHeading eyebrow="Портфолио" title="Примеры работ"/>
                        <div className={styles.examplesGrid}>
                            {posts.posts.slice(0, 3).map((post, index) => (
                                <article className={styles.exampleCard} key={post.id}>
                                    <PostBody data={post} index={index} compact showText={false}/>
                                </article>
                            ))}
                        </div>
                        <div className={styles.newsAction}>
                            <Button variant="secondary" to={EXAMPLES_ROUTE}>Все примеры работ</Button>
                        </div>
                    </section>
                )}

            </Container>
            <ExamplesByCategoryModal
                category={selectedCategory}
                show={Boolean(selectedCategory)}
                onHide={() => setSelectedCategory('')}
            />

        </>
    );
};

export default MainPage;
